import { AppDefinition } from '../../types/apps';

export const DATABASE_EVENTS = {
  OPEN: 'DATABASE_OPEN',
  CREATE: 'DATABASE_CREATE',
  ADD_ROW: 'DATABASE_ADD_ROW',
  UPDATE_CELL: 'DATABASE_UPDATE_CELL',
  DELETE_ROW: 'DATABASE_DELETE_ROW',
} as const;

export const DatabaseAppDefinition: AppDefinition = {
  appId: 'database',
  name: 'Database',
  version: '0.1.0',
  description: 'Notion-style database tables backed by River entities',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Table',
    phosphorWeight: 'duotone',
    color: '#6366f1',
    metadata: { source: 'app', appId: 'database', isAppIcon: true },
  },
  entityIcons: {
    Table: {
      type: 'phosphor',
      phosphorIcon: 'Table',
      phosphorWeight: 'duotone',
      color: '#6366f1',
    },
    TableRow: {
      type: 'phosphor',
      phosphorIcon: 'Rows',
      phosphorWeight: 'duotone',
      color: '#6366f1',
    },
    'Database.Connection': {
      type: 'phosphor',
      phosphorIcon: 'Database',
      phosphorWeight: 'duotone',
      color: '#6366f1',
    },
    'Database.SavedQuery': {
      type: 'phosphor',
      phosphorIcon: 'MagnifyingGlass',
      phosphorWeight: 'duotone',
      color: '#6366f1',
    },
  },
  events: DATABASE_EVENTS,
  entityTypes: ['Table', 'TableRow', 'Database.Connection', 'Database.SavedQuery'],
  searchableSkeletonFields: {
    Table: ['description'],
    TableRow: [],
    'Database.Connection': ['host', 'database', 'driver'],
    'Database.SavedQuery': ['query'],
  },
  agenticToolIds: ['database_query', 'database_introspect'],
  component: 'DatabaseApp',
  requiresProps: false,
  requiresEntity: false,
  actions: {},
  hidden: true,
};
